import { parseISO, differenceInMonths, differenceInYears } from 'date-fns';
import { sprintf } from 'sprintf-js';

import { translate as t } from './translate';

export const getExpirationTimeString = expirationDate => {
  const TEXTS = {
    ONE_YEAR_EXPIRATION: t('expiresInOneYear'),
    EXPIRATION_YEARS: t('expirationYears'),
    EXPIRATION_MONTHS: t('expirationMonths'),
  };
  let expirationTime = differenceInYears(parseISO(expirationDate), new Date());

  if (expirationTime === 1) return TEXTS.ONE_YEAR_EXPIRATION;
  if (expirationTime > 1)
    return sprintf(TEXTS.EXPIRATION_YEARS, expirationTime);

  expirationTime = differenceInMonths(parseISO(expirationDate), new Date());

  if (expirationTime > 1)
    return sprintf(TEXTS.EXPIRATION_MONTHS, expirationTime);

  return null;
};
